var router = require('pjax').Router;
var form = require('./form.js');
var index = require('./index.js');

router.get('content/block/:any', form);
router.get('content/block', index);
